export module UiTextAnimationModule {
  export class Service {
    private textElements: NodeListOf<HTMLElement> | undefined;
    private groupClass = 'line';

    constructor() {
      this.textElements = document.querySelectorAll('.StyledUiTextAnimation');
      if (this.textElements) {
        document.addEventListener('readCompleteAction', () => {
          this.setEvent();
        })
      }
    }

    private setEvent() {
      this.textElements?.forEach(textElement => {
        this.wrapTextWithSpans(textElement);
        this.setMaxCharCount(textElement);

        textElement.addEventListener('playAnimation', () => {
          this.playAnimation(textElement);
        });

        textElement.addEventListener('resetAnimation', () => {
          this.resetAnimation(textElement);
        });
      });
    }

    private wrapTextWithSpans(node: Node): void {
      if (node.nodeType === 3) {
        let text = node.nodeValue || '';
        text = text.trim();
        const spanWrappedText = text.split('')
          //.filter(char => char.trim().length > 0) // 空白文字をフィルタリング
          .map(char => `<span class="animationChar">${char}</span>`)
          .join('');
        const spanWrapper = document.createElement('span');
        spanWrapper.className = 'animationText';
        spanWrapper.innerHTML = spanWrappedText;
        if (node.parentNode) {
          node.parentNode.insertBefore(spanWrapper, node);
          node.parentNode.removeChild(node);
        }
      } else if (node.nodeType === 1 && node.childNodes && (node as HTMLElement).className !== 'animationText') {
        node.childNodes.forEach(childNode => this.wrapTextWithSpans(childNode));
      }
    }

    private setMaxCharCount(textElement: HTMLElement): void {
      let maxCharCount = 0;
      if (this.groupClass) {
        const groups = textElement.querySelectorAll(`.${this.groupClass}`);
        groups.forEach(group => {
          if (group.textContent && group.textContent.length > maxCharCount) {
            maxCharCount = group.textContent.length;
          }
        });
      } else {
        maxCharCount = textElement.textContent ? textElement.textContent.length : 0;
      }
      textElement.setAttribute('data-max-char-count', maxCharCount.toString());
    }

    private playAnimation(textElement: HTMLElement): void {
      const chars = textElement.querySelectorAll<HTMLElement>('.animationChar');
      const maxCharCount = parseInt(textElement.getAttribute('data-max-char-count') || '0');

      chars.forEach((char, index) => {
        char.style.animation = `text 0.01s linear ${index * 0.04}s forwards`;
      });

      if (this.groupClass) {
        const groups = textElement.querySelectorAll(`.${this.groupClass}`);
        groups.forEach(group => {
          const groupChars = group.querySelectorAll<HTMLElement>('.animationChar');
          groupChars.forEach((char, index) => {
            char.style.animation = `text 0.01s linear ${index * 0.04}s forwards`;
          });
        });
      }

      setTimeout(() => {
        textElement.style.animation = 'blink 0.1s linear 5';
      }, maxCharCount * 0.04 * 1000);

      // is-playクラスの追加
      textElement.classList.add('is-play');
    }

    private resetAnimation(textElement: HTMLElement): void {
      const chars = textElement.querySelectorAll<HTMLElement>('.animationChar');
      chars.forEach(char => {
        char.style.animation = '';
      });
      textElement.style.animation = '';

      // is-playクラスの削除
      textElement.classList.remove('is-play');
    }

  }
}
